import { useCallback } from 'react';
import { useAuthStore } from '@store/authStore';
import { authService } from '@services/authService';
import type { LoginRequest } from '@/types';

export function useAuth() {
  const { user, isAuthenticated, isLoading, setUser, setLoading, logout } = useAuthStore();

  const login = useCallback(
    async (payload: LoginRequest) => {
      setLoading(true);
      try {
        const res = await authService.login(payload);
        setUser(res.user);
        return res.user;
      } finally {
        setLoading(false);
      }
    },
    [setUser, setLoading],
  );

  const doLogout = useCallback(async () => {
    await authService.logout();
    logout();
  }, [logout]);

  return { user, isAuthenticated, isLoading, login, logout: doLogout };
}
